import React from 'react';
import WidgetContainer from '~shared/ui/WidgetContainer';
import TabsMenu from '~scenes/madeforyou/app/components/tabs/TabsMenu';
import {
    MADE_FOR_YOU_GA_COMPONENT_HOME_TYPES,
    I18N_MADE_FOR_YOU,
    MADE_FOR_YOU_GTM_SEE_ALL,
} from '~scenes/madeforyou/constants';
import { useSelector } from 'react-redux';
import { selectActiveTab } from '~scenes/madeforyou/app/selectors/mfySelectors';
import TabsContent from '~scenes/madeforyou/app/components/tabs/TabsContent';
import i18n from '~shared/utils/i18n';
import { generateMfySeoUrl, getGtmPrefix } from '~scenes/madeforyou/utils';
import { useMFYReady } from '~scenes/madeforyou/utils';


const MadeForYouWidget = () => {
    const isReady = useMFYReady({isWidget: true});
    const activeTab = useSelector(selectActiveTab);
    const gaComponent = MADE_FOR_YOU_GA_COMPONENT_HOME_TYPES.get(activeTab);
    const gtmPrefix = getGtmPrefix(activeTab, true);
    const gtmFooter = `${gtmPrefix};${MADE_FOR_YOU_GTM_SEE_ALL}`;

    return isReady && (
        <div className='made-for-you'>
            <WidgetContainer
                title={i18n.t(I18N_MADE_FOR_YOU)}
                titleIconClassName='made-for-you'
                titleLink={generateMfySeoUrl(activeTab)}
                gaComponent={gaComponent}
                gtmAttribute={gtmFooter}
            >
                <TabsMenu />
                <TabsContent />
            </WidgetContainer>
        </div>
    );
};

export default MadeForYouWidget;
